import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Global dev-overlay noise suppression for ResizeObserver warnings (non-invasive)
(() => {
  if (typeof window === 'undefined') return;
  // Guard to avoid double-install
  if (window.__suppressROErrorsInstalled) return;
  window.__suppressROErrorsInstalled = true;

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    try {
      const hasResizeObserverMsg = args.some((arg) => {
        if (!arg) return false;
        if (typeof arg === 'string') {
          return (
            arg.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.includes('ResizeObserver loop limit exceeded')
          );
        }
        if (arg instanceof Error && typeof arg.message === 'string') {
          return (
            arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.message.includes('ResizeObserver loop limit exceeded')
          );
        }
        return false;
      });
      if (hasResizeObserverMsg) return;
    } catch (_) {}
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    try {
      const hasResizeObserverMsg = args.some((arg) => {
        if (!arg) return false;
        if (typeof arg === 'string') {
          return (
            arg.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.includes('ResizeObserver loop limit exceeded')
          );
        }
        if (arg instanceof Error && typeof arg.message === 'string') {
          return (
            arg.message.includes('ResizeObserver loop completed with undelivered notifications') ||
            arg.message.includes('ResizeObserver loop limit exceeded')
          );
        }
        return false;
      });
      if (hasResizeObserverMsg) return;
    } catch (_) {}
    originalWarn.apply(console, args);
  };

  const stopROOverlay = (event) => {
    const msg = event?.message || '';
    if (
      typeof msg === 'string' && (
        msg.includes('ResizeObserver loop completed with undelivered notifications') ||
        msg.includes('ResizeObserver loop limit exceeded')
      )
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };
  const stopRORejection = (event) => {
    const reason = event?.reason;
    const msg = (typeof reason === 'string') ? reason : (reason?.message || '');
    if (
      typeof msg === 'string' && (
        msg.includes('ResizeObserver loop completed with undelivered notifications') ||
        msg.includes('ResizeObserver loop limit exceeded')
      )
    ) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  };
  window.addEventListener('error', stopROOverlay, true);
  window.addEventListener('unhandledrejection', stopRORejection, true);

  // Hide only the dev overlay that shows the specific ResizeObserver messages (keep other overlays)
  const hideSpecificOverlay = () => {
    try {
      // Inject a stylesheet once to always hide specific overlay elements
      if (!window.__roOverlayStyleInjected) {
        const style = document.createElement('style');
        style.setAttribute('data-ro-overlay-style', '');
        style.textContent = `
          #webpack-dev-server-client-overlay,
          #webpack-dev-server-overlay,
          #react-error-overlay,
          iframe#webpack-dev-server-client-overlay {
            display: none !important;
            visibility: hidden !important;
            pointer-events: none !important;
            opacity: 0 !important;
          }
        `;
        document.head.appendChild(style);
        window.__roOverlayStyleInjected = true;
      }

      // Additionally, hide any existing overlay nodes explicitly
      const selectors = [
        '#webpack-dev-server-client-overlay',
        '#webpack-dev-server-overlay',
        '#react-error-overlay',
        'iframe#webpack-dev-server-client-overlay'
      ];
      selectors.forEach((sel) => {
        const el = document.querySelector(sel);
        if (el) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.pointerEvents = 'none';
          el.style.opacity = '0';
        }
      });
    } catch (_) {}
  };
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    hideSpecificOverlay();
  } else {
    window.addEventListener('DOMContentLoaded', hideSpecificOverlay, { once: true });
  }
  const mo = new MutationObserver(() => hideSpecificOverlay());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
); 